export default __webpack_public_path__ + "a129db29cf4480f79bd41a0c3a94c31c.png";